import { motion } from "framer-motion";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-black/50 backdrop-blur-xl border-b border-white/10 saturate-150"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => scrollTo("top")}
          className="flex items-center gap-2 group"
        >
          <span className="font-future text-base tracking-tight">PivoT</span>
          <span className="font-origin italic text-lg text-white/70 group-hover:text-white transition-colors duration-300">
            ransition
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8 label-caps text-white/60">
          <button onClick={() => scrollTo("manifesto")} className="hover:text-white transition-colors duration-300" data-testid="nav-manifesto">Manifesto</button>
          <button onClick={() => scrollTo("free")} className="hover:text-white transition-colors duration-300" data-testid="nav-free">Free PDF</button>
          <button onClick={() => scrollTo("inside")} className="hover:text-white transition-colors duration-300" data-testid="nav-inside">Inside</button>
          <button onClick={() => scrollTo("guides")} className="hover:text-white transition-colors duration-300" data-testid="nav-guides">Guides</button>
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => scrollTo("guides")}
          className="label-caps px-5 py-2 rounded-full bg-white text-black hover:bg-[var(--neon-cyan)] transition-colors duration-300"
        >
          Get the Guide
        </button>
      </div>
    </motion.header>
  );
};
